import React, { useState } from "react";
import { MAP1, MAP2, MAP3 } from "../../../static/contents/map";
import { TITLE } from "../../../static/contents/title";
import { gtagSendEvent } from "../../pages";
import { StyledButton } from "../Buttons/StyledButton/StyledButton";
import { Title } from "../Title/Title";
import { BoxAccordion } from "./BoxAccordion";
import * as styles from "./mapAccordion.module.scss";

export const MapAccordion: React.FC = () => {
  const [state, setState] = useState<number>(0);
  const [open0, setOpen0] = useState<number>();
  const [open1, setOpen1] = useState<number>();
  const [open2, setOpen2] = useState<number>();

  return (
    <div className={styles.wrapper}>
      <div className={styles.buttons}>
        <StyledButton
          children={"Day 1"}
          onClick={() => {
            setState(0);
            gtagSendEvent("click", "day1");
          }}
          className={state === 0 ? styles.rouge : ""}
        />
        <StyledButton
          children={"Day 2"}
          onClick={() => {
            setState(1);
            gtagSendEvent("click", "day2");
          }}
          className={state === 1 ? styles.rouge : ""}
        />
        <StyledButton
          children={"Day 3"}
          onClick={() => {
            setState(2);
            gtagSendEvent("click", "day3");
          }}
          className={state === 2 ? styles.rouge : ""}
        />
      </div>
      {state === 0 && <Title text={TITLE.title32} className={styles.timing} />}
      {state === 1 && <Title text={TITLE.title33} className={styles.timing} />}
      {state === 2 && <Title text={TITLE.title34} className={styles.timing} />}
      {state === 0 &&
        MAP1.map((box: any, index: number) => {
          return (
            <div className={styles.wrapper}>
              <div key={`accordion1-${index}`}>
                <BoxAccordion
                  hashtag={box.hashtag}
                  title={box.title}
                  text={box.text}
                  subtitle={box.subtitle}
                  text1={box.text1}
                  text2={box.text2}
                  text3={box.text3}
                  text4={box.text4}
                  text5={box.text5}
                  open={open0}
                  handleClick={() => setOpen0(index === open0 ? -1 : index)}
                  index={index}
                  comingsoon={box.comingsoon}
                />
              </div>
            </div>
          );
        })}
      {state === 1 &&
        MAP2.map((box: any, index: number) => {
          return (
            <div className={styles.wrapper}>
              <div key={`accordion2-${index}`}>
                <BoxAccordion
                  hashtag={box.hashtag}
                  title={box.title}
                  text={box.text}
                  subtitle={box.subtitle}
                  text1={box.text1}
                  text2={box.text2}
                  text3={box.text3}
                  text4={box.text4}
                  text5={box.text5}
                  open={open1}
                  handleClick={() => setOpen1(index === open1 ? -1 : index)}
                  index={index}
                  comingsoon={box.comingsoon}
                />
              </div>
            </div>
          );
        })}
      {state === 2 &&
        MAP3.map((box: any, index: number) => {
          return (
            <div className={styles.wrapper}>
              <div key={`accordion3-${index}`}>
                <BoxAccordion
                  hashtag={box.hashtag}
                  title={box.title}
                  text={box.text}
                  subtitle={box.subtitle}
                  text1={box.text1}
                  text2={box.text2}
                  text3={box.text3}
                  text4={box.text4}
                  text5={box.text5}
                  open={open2}
                  handleClick={() => setOpen2(index === open2 ? -1 : index)}
                  index={index}
                  comingsoon={box.comingsoon}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
};
